export class SchemaStatus {
  public static readonly Unregistered = 'Unregistered';
  public static readonly Registered = 'Registered';

  public static get() {
    return { Unregistered : this.Unregistered, Registered: this.Registered}
  }
}
